import { useState, useEffect, useCallback } from 'react';
import LZString from 'lz-string';

const useSnapshotShare = (currentState, setGlobalState, queryKey = 's') => {
    const [showToast, setShowToast] = useState(false);

    // Hydrate from URL on mount
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const data = params.get(queryKey);
        if (data) {
            try {
                const decompressed = LZString.decompressFromEncodedURIComponent(data);
                if (decompressed) {
                    const parsed = JSON.parse(decompressed);
                    setGlobalState(parsed);
                }
            } catch (e) {
                console.error("Failed to load snapshot", e);
            }
        }
    }, [setGlobalState, queryKey]);

    // Cleanup toast timer
    useEffect(() => {
        let timer;
        if (showToast) {
            timer = setTimeout(() => setShowToast(false), 6000);
        }
        return () => clearTimeout(timer);
    }, [showToast]);

    const handleShare = useCallback(() => {
        const json = JSON.stringify(currentState);
        const compressed = LZString.compressToEncodedURIComponent(json);
        const url = new URL(window.location);
        url.searchParams.set(queryKey, compressed);
        window.history.replaceState(null, '', url);

        navigator.clipboard.writeText(url.toString());
        setShowToast(true);
    }, [currentState, queryKey]);

    return { handleShare, showToast, setShowToast };
};

export default useSnapshotShare;
